<template>
    <section class="tool-holder">
        <div class="tool-container">
            <div class="tool__question-holder">
                <h2 class="tool__title">{{ question.title }}</h2>
                <div class="tool__text-holder" v-if="question.text">
                    <p class="tool__text">{{ question.text }}</p>
                </div>
            </div>
            <div class="summary__holder tool__answer-holder--column">
                <div class="summary__container">
                    <div class="summary__block">
                        <img :src="info.homeType.icon" :alt="info.homeType.label" />
                        <span class="summary__block-label">{{ info.homeType.label }}</span>
                    </div>
                    <div class="summary__block">
                        <span class="summary__block-value">{{ info.energielabel.icon }}</span>
                        <span class="summary__block-label">{{ info.energielabel.label }}</span>
                    </div>
                    <div class="summary__block">
                        <span class="summary__block-value">{{ info.buildYear.year }}</span>
                        <span class="summary__block-label">{{ info.buildYear.label }}</span>
                    </div>
                    <div class="summary__block">
                        <span class="summary__block-value">{{ info.surface.amount }} m<sup>2</sup></span>
                        <span class="summary__block-label">{{ info.surface.label }}</span>
                    </div>
                </div>
                <p class="tool__text">Woon je hier al?</p>
                <div class="tool__answer-holder radio-button__yes-no">
                    <div v-for="(answer, index) in question.answers" :key="question.slug + index" class="radio-button-holder radio-button-holder--boxed" :class="{ 'success' : answers[0] === answer.text }" @click="addToStore(answer.text)">
                        <input
                            type="radio"
                            :id="answer.text + index"
                            :name="question.slug"
                            :ref="answer.text"
                            :checked="answers[0] === answer.text"
                        />
                        <label :for="answer.text + index">{{ answer.text }}</label>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import store from '../../store/store';

export default {
    props: {
        question: {
            type: Object
        }
    },

    data() {
        return {
            store,
            answers: null,
            isLoading: true,
        }
    },

    created() {
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;

        const energyLabel = this.store.questionAnswers[1].answers[0] === 'Ik weet het niet' ? '-' : this.store.questionAnswers[1].answers[0].split(' ')[1];

        this.info = {
            homeType: {
                icon: `/media/images/tool/icons/woning-type-${this.store.questionAnswers[0].answers[0].split(' ').join('-')}.svg`,
                label: this.store.questionAnswers[0].answers[0]
            },
            energielabel: {
                icon: energyLabel,
                label: this.store.questionAnswers[1].answers[0]
            },
            buildYear: {
                year: this.store.kadaster.buildYear,
                label: 'bouwjaar'
            },
            surface: {
                amount: this.store.kadaster.surface,
                label: 'oppervlakte'
            }
        };
    },

    mounted() {
        
    },

    methods: {
        addToStore(value) {
            const radio = this.$refs[value][0];
            radio.click();
            this.answers = [value];

            if (this.question.slug === 'ventilatie' && value.toLowerCase() === 'ja') {
                this.store.questionInfo[this.store.currentQuestionIndex].showSideQuestions = true;
            }

            if (this.question.isSideQuestion) {
                this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] = this.answers;
                return;
            }

            this.store.kadaster.livesHere = this.answers[0] || 'Nee';
            this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
        },
    },

    updated() {
        // Reset answers for when there are multiple radio questions after each other. This will prevent the template to have a success class on the fields when the user hasn't selected anything
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    }
}
</script>
